import React from "react";

// Tarjeta de acompañamiento/confianza para el flujo de compra (verServicio, Reserva, Pago) — mismos
// datos de contacto que ya usan footer.jsx y Soporte.jsx (no se inventa un canal nuevo). La idea es
// darle al comprador un empujón profesional para terminar la compra: si tiene dudas, puede resolverlas
// al instante en vez de abandonar el proceso.
//
// El número se muestra como texto (no solo como botón "Llamar"): en escritorio el link `tel:` no
// hace nada por sí solo (no hay app de teléfono asociada), así que sin el número visible no había
// forma real de llamar desde el PC — el usuario tendría que copiarlo de otro lado.
function Llamanos() {
  return (
    <div
      className="rounded-4 p-3 p-md-4"
      style={{
        background: "linear-gradient(135deg, var(--azul-medio) 0%, var(--azul-logo-claro) 100%)",
        boxShadow: "0 10px 26px rgba(var(--azul-logo-claro-rgb), 0.28)",
      }}
    >
      <div className="d-flex align-items-start gap-3 mb-3">
        <div
          className="d-flex align-items-center justify-content-center flex-shrink-0"
          style={{
            width: 42,
            height: 42,
            borderRadius: 12,
            background: "rgba(var(--blanco-rgb), 0.16)",
            color: "var(--blanco)",
          }}
        >
          <i className="bi bi-headset"></i>
        </div>

        <div className="flex-grow-1">
          <div className="fw-bold text-white" style={{ fontSize: 15 }}>¿Dudas con tu reserva?</div>
          <div className="text-white" style={{ fontSize: 13, lineHeight: 1.5, opacity: 0.85 }}>
            Llámanos y resolvemos tus dudas al instante, para que completes tu compra con total confianza.
          </div>
        </div>
      </div>

      {/* Fila de teléfonos a todo el ancho de la tarjeta (no angostada bajo el texto) — solo
          teléfonos (ícono de teléfono, no de WhatsApp): ese canal ya está cubierto por el botón
          flotante de la página, repetirlo acá era redundante. */}
      <div className="d-flex gap-2">
        <a
          href="tel:+573124964754"
          className="flex-fill d-flex align-items-center justify-content-center gap-2 text-decoration-none rounded-3 px-2 py-2"
          style={{ background: "rgba(var(--blanco-rgb),0.14)", color: "var(--blanco)", fontSize: 13, minWidth: 0 }}
        >
          <i className="bi bi-telephone-fill flex-shrink-0"></i>
          <span className="fw-semibold text-truncate">+57 312 496 4754</span>
        </a>
        <a
          href="tel:+573189859423"
          className="flex-fill d-flex align-items-center justify-content-center gap-2 text-decoration-none rounded-3 px-2 py-2"
          style={{ background: "rgba(var(--blanco-rgb),0.14)", color: "var(--blanco)", fontSize: 13, minWidth: 0 }}
        >
          <i className="bi bi-telephone-fill flex-shrink-0"></i>
          <span className="fw-semibold text-truncate">+57 318 985 9423</span>
        </a>
      </div>
    </div>
  );
}

export default Llamanos;
